import React, { useEffect, useContext}from "react";
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import RedefinirSenha from "beaktShared/views/GenericPages/RedefinirSenha";

import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import InputAdornment from '@material-ui/core/InputAdornment';
import FormHelperText from "@material-ui/core/FormHelperText";

// icons
import LoadingIcon from "@material-ui/icons/Cached";
import "beaktShared/components/CustomInput/rotate.css";
import { SessionContext } from "beaktShared/services/session";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Clearfix from "beaktShared/components/Clearfix/Clearfix.js";
import Card from "beaktShared/components/Card/Card.js";
import CardAvatar from "beaktShared/components/Card/CardAvatar.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import NavPills from "beaktShared/components/NavPills/NavPills.js";
import avatar from "assets/img/faces/avatar.png";

import Info from "@material-ui/icons/Info";
import Lock from "@material-ui/icons/Lock";

import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

import { UseGetApiSimple, UsePutApi } from "beaktShared/services/crudeApiService";
const useStyles = makeStyles(styles);

export default function UserProfile() {
  const { t } = useTranslation();
  const session = useContext(SessionContext);
  
  const { register, handleSubmit, setError, setValue, errors, clearError, getValues } = useForm({mode: "onBlur"});
     
  const [loading, setLoading] = React.useState(false);

  const [notification, setNotification] = React.useState(false);
  const [userupdate, setuserupdate] = React.useState({});
  const [colorNotification, setColorNotification] = React.useState('info');
  const [mensagemNotification, setMensagemNotification] = React.useState(false);
  const showNotification = (mensagem,color) => {
      setMensagemNotification(mensagem);
      setColorNotification(color);
      setNotification(true);
      setTimeout(function() {
          setNotification(false);
      }, 6000);
  };

  useEffect(() => {
    LoadUserProfile(); 
  // eslint-disable-next-line
  }, []);

  const LoadUserProfile = () => {
    const endPoint = 'usuarios/'+session.id;
    UseGetApiSimple(endPoint).then(result=>{
      if(result.status !== 200)
      {
        //showNotification(result.message,'danger');
        return false;
      }
      let item = result.data;
      setuserupdate(result.data);     
      setValue('id', item.usuarioId);
      setValue('nome', item.nome);
      setValue('email', item.email);
      setValue('login', item.login);
      return true;
    });
  }

  const [loadingValidateEmail, setloadingValidateEmail] = React.useState(false);
  const [validateEmail, setvalidateEmail] = React.useState(false);
  const handleEmailChange = e =>{
    let email = e.target.value;
    if (email==="")
        return;

    let data = getValues()
        
    setloadingValidateEmail(true);
    const endPoint = "usuarios/vefifyemail/"+email+"/"+parseInt(data.usuarioId);
    UseGetApiSimple(endPoint,0).then(result=>{
      if(result.status !== 200)
      {
          //showNotification(result.message,'danger');
          setloadingValidateEmail(false);
          return false;
      }  
      setvalidateEmail(result.data);
      if(result.data)
          setError("email", "invalidemail", t('error_messsage.existing_email_choose_another')+".")
      else
          clearError("email");
      setloadingValidateEmail(false);
    });
  }

  const onSubmit = (data, e) => {
    setLoading(true);
    

    e.preventDefault();
    if (validateEmail) {
      setLoading(false);
      return setError("emailUsuario", "invalidemail", t('error_messsage.existing_email_choose_another')+".") 
    }

    userupdate.nome = data.nome;
    userupdate.email = data.email;
    userupdate.login = data.login;
      
    let endPoint = 'usuarios/';
    UsePutApi(endPoint, data.id, userupdate).then(result=>{      
      if(result.status !== 200)
      {
          showNotification(result.message,'danger');
          return false;
      }
  
      setLoading(false);
      showNotification(result.message,'success');
      return true;
    });
  };

  const classes = useStyles();
  return (
    <div>
      
        <Snackbar
            place="tr"
            color={colorNotification}
            message={mensagemNotification}
            open={notification}
            closeNotification={() => setNotification(false)}
            close
        />
        <GridContainer>
        <GridItem xs={12} sm={12} md={8}>

          <NavPills
            color="primary"
            alignLeft
            tabs={[
              {
                tabButton: t('sidebar.profile'),
                tabIcon: Info,
                tabContent: (
                  <Card>
                    <CardHeader>
                      <h4 className={classes.cardTitle}>
                        {t('label.edit_profile')}
                      </h4>
                    </CardHeader>
                    <CardBody>
                    <form onSubmit={handleSubmit(onSubmit)}>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                          <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.nome?true:false}
                                label={t('label.name')}
                                variant="outlined"
                                inputRef={register({required: true})}
                                name="nome"
                                InputLabelProps={{shrink: true}}
                            />
                            <FormHelperText className={classes.labelRootError}>
                                {errors.nome && <span>{t('label.required')} </span>}
                            </FormHelperText>
                          </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                          <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.login?true:false}
                                label={t('login.login')}
                                variant="outlined"
                                disabled={true}
                                inputRef={register({required: true})}
                                name="login"
                                InputLabelProps={{shrink: true}}
                            />
                            <FormHelperText className={classes.labelRootError}>
                                {errors.login && <span>{t('label.required')} </span>}
                            </FormHelperText>
                          </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                          <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.email?true:false}
                                label={t('label.email')}
                                variant="outlined"
                                disabled={true}
                                onBlur={handleEmailChange}
                                inputRef={register({
                                  required: t('label.required'),
                                  pattern: {
                                    value: /^\S+@\S+$/i,
                                    message: t('label.invalid_email')
                                  }
                                })}
                                name="email"
                                InputLabelProps={{shrink: true}}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      {loadingValidateEmail && <LoadingIcon className="rotate" />}
                                    </InputAdornment>
                                  ),
                                }}
                            />
                            <FormHelperText className={classes.labelRootError}>
                                {errors.email && <span>{t('label.required')} </span>}
                            </FormHelperText>
                          </FormControl>
                        </GridItem>
                      </GridContainer>
                      <Button type="submit" color="primary" className={classes.updateProfileButton}>
                        {t('button.update')}
                        {loading && <div> ...{t('label.loading')} </div>}
                      </Button>
                      <Clearfix />
                      </form>
                    </CardBody>
                  </Card>
                )
              },
              {
                tabButton: t('login.password'),
                tabIcon: Lock,
                tabContent: (
                  <Card>
                    <CardHeader>
                      <h4 className={classes.cardTitle}>
                        {t('login.set_new_password')}
                      </h4>
                    </CardHeader>
                    <CardBody>

                      <RedefinirSenha/>

                    </CardBody>
                  </Card>
                )
              }
            ]}
          />

          
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          <Card profile>
            <CardAvatar profile>
              <a href="#pablo" onClick={e => e.preventDefault()}>
                <img src={avatar} alt="..." />
              </a>
            </CardAvatar>
            <CardBody profile>
              <h6 className={classes.cardCategory}>Administrador</h6>
              <h4 className={classes.cardTitle}>{userupdate.nome}</h4>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
